(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ex-loyalty"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      var root = document.getElementById('xloyalty');
      if (!root) return;

      /* Einblenden + FAQ */
      var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('in'); io.unobserve(entry.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' }) : null;
      root.querySelectorAll('.rv').forEach(function (el) { io ? io.observe(el) : el.classList.add('in'); });
      root.querySelectorAll('#xl-faq .q').forEach(function (q) {
        var btn = q.querySelector('button'), a = q.querySelector('.a');
        btn.addEventListener('click', function () {
          var open = q.classList.contains('open');
          root.querySelectorAll('#xl-faq .q.open').forEach(function (o) { o.classList.remove('open'); o.querySelector('.a').style.maxHeight = '0'; });
          if (!open) { q.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
        });
      });


      /* ---------- Freunde einladen (Redeemly) ----------
         Redeemly-Referral-Embed stellt window.mcb_referral bereit (Programm, Beträge, Mindestwert).
         Der persönliche Link ist derselbe, den Redeemly im eigenen Launcher erzeugt:
         <shop>/?redeemly_ref_code=<Sqids([shopId, customerId], minLength 10)> – Sqids-Code aus Redeemly 2.70.2 übernommen. */
      var RL = root.getAttribute('data-locale') || 'de';
      function rEur(n) { var v = Math.round(n * 100) / 100; var t = (v % 1) ? v.toFixed(2) : String(v); if (RL !== 'en') t = t.replace('.', ','); return RL === 'en' ? '\u20ac' + t : t + ' \u20ac'; }
      var RM = window.mcb_referral || null, RP = RM && RM.referralProgram;
      var refOn = !!(RP && RP.status !== 'disabled' && RP.status !== 'inactive');
      var refF = null, refY = null;
      if (refOn) {
        refF = rEur(+RP.refereeRewardAmount || 0);
        refY = RP.referrerRewardType === 'percentage_off_order' ? (+RP.referrerRewardAmount || 0) + ' %' : rEur(+RP.referrerRewardAmount || 0);
        root.querySelectorAll('[data-ref-amt="friend"]').forEach(function (e) { e.textContent = refF; });
        root.querySelectorAll('[data-ref-amt="you"]').forEach(function (e) { e.textContent = refY; });
        var terms = root.querySelector('[data-ref-terms]');
        if (terms) {
          var parts = [], gs = RM.globalSettings || {}, rule = gs.hidesPaymentOptionRules && gs.hidesPaymentOptionRules.orderAmountRule;
          if (rule && rule.enabled && +rule.amount > 0) parts.push(terms.getAttribute('data-min').replace('{m}', rEur(+rule.amount)));
          if (+RP.expiresAfterDays > 0) parts.push(terms.getAttribute('data-exp').replace('{d}', RP.expiresAfterDays));
          if (parts.length) { terms.textContent = parts.join(' '); terms.hidden = false; }
        }
      }
      function refLink() {
        var cid = root.getAttribute('data-cid'); if (!refOn || !cid) return null;
        try {
          var XLSQ = (function () { var Dr={alphabet:"abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",minLength:0,blocklist:new Set(["0rgasm","1d10t","1d1ot","1di0t","1diot","1eccacu10","1eccacu1o","1eccacul0","1eccaculo","1mbec11e","1mbec1le","1mbeci1e","1mbecile","a11upat0","a11upato","a1lupat0","a1lupato","aand","ah01e","ah0le","aho1e","ahole","al1upat0","al1upato","allupat0","allupato","ana1","ana1e","anal","anale","anus","arrapat0","arrapato","arsch","arse","ass","b00b","b00be","b01ata","b0ceta","b0iata","b0ob","b0obe","b0sta","b1tch","b1te","b1tte","ba1atkar","balatkar","bastard0","bastardo","batt0na","battona","bitch","bite","bitte","bo0b","bo0be","bo1ata","boceta","boiata","boob","boobe","bosta","bran1age","bran1er","bran1ette","bran1eur","bran1euse","branlage","branler","branlette","branleur","branleuse","c0ck","c0g110ne","c0g11one","c0g1i0ne","c0g1ione","c0gl10ne","c0gl1one","c0gli0ne","c0glione","c0na","c0nnard","c0nnasse","c0nne","c0u111es","c0u11les","c0u1l1es","c0u1lles","c0ui11es","c0ui1les","c0uil1es","c0uilles","c11t","c11t0","c11to","c1it","c1it0","c1ito","cabr0n","cabra0","cabrao","cabron","caca","cacca","cacete","cagante","cagar","cagare","cagna","cara1h0","cara1ho","caracu10","caracu1o","caracul0","caraculo","caralh0","caralho","cazz0","cazz1mma","cazzata","cazzimma","cazzo","ch00t1a","ch00t1ya","ch00tia","ch00tiya","ch0d","ch0ot1a","ch0ot1ya","ch0otia","ch0otiya","ch1asse","ch1avata","ch1er","ch1ng0","ch1ngadaz0s","ch1ngadazos","ch1ngader1ta","ch1ngaderita","ch1ngar","ch1ngo","ch1ngues","ch1nk","chatte","chiasse","chiavata","chier","ching0","chingadaz0s","chingadazos","chingader1ta","chingaderita","chingar","chingo","chingues","chink","cho0t1a","cho0t1ya","cho0tia","cho0tiya","chod","choot1a","choot1ya","chootia","chootiya","cl1t","cl1t0","cl1to","clit","clit0","clito","cock","cog110ne","cog11one","cog1i0ne","cog1ione","cogl10ne","cogl1one","cogli0ne","coglione","cona","connard","connasse","conne","cou111es","cou11les","cou1l1es","cou1lles","coui11es","coui1les","couil1es","couilles","cracker","crap","cu10","cu1att0ne","cu1attone","cu1er0","cu1ero","cu1o","cul0","culatt0ne","culattone","culer0","culero","culo","cum","cunt","d11d0","d11do","d1ck","d1ld0","d1ldo","damn","de1ch","deich","depp","di1d0","di1do","dick","dild0","dildo","dyke","encu1e","encule","enema","enf01re","enf0ire","enfo1re","enfoire","estup1d0","estup1do","estupid0","estupido","etr0n","etron","f0da","f0der","f0ttere","f0tters1","f0ttersi","f0tze","f0utre","f1ca","f1cker","f1ga","fag","fica","ficker","figa","foda","foder","fottere","fotters1","fottersi","fotze","foutre","fr0c10","fr0c1o","fr0ci0","fr0cio","fr0sc10","fr0sc1o","fr0sci0","fr0scio","froc10","froc1o","froci0","frocio","frosc10","frosc1o","frosci0","froscio","fuck","g00","g0o","g0u1ne","g0uine","gandu","go0","goo","gou1ne","gouine","gr0gnasse","grognasse","haram1","harami","haramzade","hund1n","hundin","id10t","id1ot","idi0t","idiot","imbec11e","imbec1le","imbeci1e","imbecile","j1zz","jerk","jizz","k1ke","kam1ne","kamine","kike","leccacu10","leccacu1o","leccacul0","leccaculo","m1erda","m1gn0tta","m1gnotta","m1nch1a","m1nchia","m1st","mam0n","mamahuev0","mamahuevo","mamon","masturbat10n","masturbat1on","masturbate","masturbati0n","masturbation","merd0s0","merd0so","merda","merde","merdos0","merdoso","mierda","mign0tta","mignotta","minch1a","minchia","mist","musch1","muschi","n1gger","neger","negr0","negre","negro","nerch1a","nerchia","nigger","orgasm","p00p","p011a","p01la","p0l1a","p0lla","p0mp1n0","p0mp1no","p0mpin0","p0mpino","p0op","p0rca","p0rn","p0rra","p0uff1asse","p0uffiasse","p1p1","p1pi","p1r1a","p1rla","p1sc10","p1sc1o","p1sci0","p1scio","p1sser","pa11e","pa1le","pal1e","palle","pane1e1r0","pane1e1ro","pane1eir0","pane1eiro","panele1r0","panele1ro","paneleir0","paneleiro","patakha","pec0r1na","pec0rina","pecor1na","pecorina","pen1s","pendej0","pendejo","penis","pip1","pipi","pir1a","pirla","pisc10","pisc1o","pisci0","piscio","pisser","po0p","po11a","po1la","pol1a","polla","pomp1n0","pomp1no","pompin0","pompino","poop","porca","porn","porra","pouff1asse","pouffiasse","pr1ck","prick","pussy","put1za","puta","puta1n","putain","pute","putiza","puttana","queca","r0mp1ba11e","r0mp1ba1le","r0mp1bal1e","r0mp1balle","r0mpiba11e","r0mpiba1le","r0mpibal1e","r0mpiballe","rand1","randi","rape","recch10ne","recch1one","recchi0ne","recchione","retard","romp1ba11e","romp1ba1le","romp1bal1e","romp1balle","rompiba11e","rompiba1le","rompibal1e","rompiballe","ruff1an0","ruff1ano","ruffian0","ruffiano","s1ut","sa10pe","sa1aud","sa1ope","sacanagem","sal0pe","salaud","salope","saugnapf","sb0rr0ne","sb0rra","sb0rrone","sbattere","sbatters1","sbattersi","sborr0ne","sborra","sborrone","sc0pare","sc0pata","sch1ampe","sche1se","sche1sse","scheise","scheisse","schlampe","schwachs1nn1g","schwachs1nnig","schwachsinn1g","schwachsinnig","schwanz","scopare","scopata","sexy","sh1t","shit","slut","sp0mp1nare","sp0mpinare","spomp1nare","spompinare","str0nz0","str0nza","str0nzo","stronz0","stronza","stronzo","stup1d","stupid","succh1am1","succh1ami","succhiam1","succhiami","sucker","t0pa","tapette","test1c1e","test1cle","testic1e","testicle","tette","topa","tr01a","tr0ia","tr0mbare","tr1ng1er","tr1ngler","tring1er","tringler","tro1a","troia","trombare","turd","twat","vaffancu10","vaffancu1o","vaffancul0","vaffanculo","vag1na","vagina","verdammt","verga","w1chsen","wank","wichsen","x0ch0ta","x0chota","xana","xoch0ta","xochota","z0cc01a","z0cc0la","z0cco1a","z0ccola","z1z1","z1zi","ziz1","zizi","zocc01a","zocc0la","zocco1a","zoccola"])};class Wr{constructor(e){var t,n,r;const a=null!==(t=null==e?void 0:e.alphabet)&&void 0!==t?t:Dr.alphabet,o=null!==(n=null==e?void 0:e.minLength)&&void 0!==n?n:Dr.minLength,i=null!==(r=null==e?void 0:e.blocklist)&&void 0!==r?r:Dr.blocklist;if(new Blob([a]).size!==a.length)throw new Error("Alphabet cannot contain multibyte characters");if(a.length<3)throw new Error("Alphabet length must be at least 3");if(new Set(a).size!==a.length)throw new Error("Alphabet must contain unique characters");if("number"!=typeof o||o<0||o>255)throw new Error("Minimum length has to be between 0 and 255");const l=new Set,c=a.toLowerCase().split("");for(const e of i)if(e.length>=3){const t=e.toLowerCase(),n=t.split(""),r=n.filter((e=>c.includes(e)));r.length===n.length&&l.add(t)}this.alphabet=this.shuffle(a),this.minLength=o,this.blocklist=l}encode(e){if(0===e.length)return"";const t=e.filter((e=>e>=0&&e<=this.maxValue()));if(t.length!==e.length)throw new Error(`Encoding supports numbers between 0 and ${this.maxValue()}`);return this.encodeNumbers(e)}decode(e){const t=[];if(""===e)return t;const n=this.alphabet.split("");for(const r of e.split(""))if(!n.includes(r))return t;const r=e.charAt(0),a=this.alphabet.indexOf(r);let o=this.alphabet.slice(a)+this.alphabet.slice(0,a);o=o.split("").reverse().join("");let i=e.slice(1);for(;i.length>0;){const e=o.slice(0,1),n=i.split(e);if(n.length>0){if(""===n[0])return t;t.push(this.toNumber(n[0],o.slice(1))),n.length>1&&(o=this.shuffle(o))}i=n.slice(1).join(e)}return t}encodeNumbers(e,t=0){if(t>this.alphabet.length)throw new Error("Reached max attempts to re-generate the ID");let n=e.reduce(((e,t,n)=>this.alphabet[t%this.alphabet.length].codePointAt(0)+n+e),e.length)%this.alphabet.length;n=(n+t)%this.alphabet.length;let r=this.alphabet.slice(n)+this.alphabet.slice(0,n);const a=r.charAt(0);r=r.split("").reverse().join("");const o=[a];for(let t=0;t!==e.length;t++){const n=e[t];o.push(this.toId(n,r.slice(1))),t<e.length-1&&(o.push(r.slice(0,1)),r=this.shuffle(r))}let i=o.join("");if(this.minLength>i.length)for(i+=r.slice(0,1);this.minLength-i.length>0;)r=this.shuffle(r),i+=r.slice(0,Math.min(this.minLength-i.length,r.length));return this.isBlockedId(i)&&(i=this.encodeNumbers(e,t+1)),i}shuffle(e){const t=e.split("");for(let e=0,n=t.length-1;n>0;e++,n--){const r=(e*n+t[e].codePointAt(0)+t[n].codePointAt(0))%t.length;[t[e],t[r]]=[t[r],t[e]]}return t.join("")}toId(e,t){const n=[],r=t.split("");let a=e;do{n.unshift(r[a%r.length]),a=Math.floor(a/r.length)}while(a>0);return n.join("")}toNumber(e,t){const n=t.split("");return e.split("").reduce(((e,t)=>e*n.length+n.indexOf(t)),0)}isBlockedId(e){const t=e.toLowerCase();for(const e of this.blocklist)if(e.length<=t.length)if(t.length<=3||e.length<=3){if(t===e)return!0}else if(/\d/.test(e)){if(t.startsWith(e)||t.endsWith(e))return!0}else if(t.includes(e))return!0;return!1}maxValue(){return Number.MAX_SAFE_INTEGER} }; return Wr; })();
          var shop = (RM.globalSettings && RM.globalSettings.shopId) || '86607757638';
          return location.origin + '/?redeemly_ref_code=' + new XLSQ({ minLength: 10 }).encode([parseInt(shop, 10), parseInt(cid, 10)]);
        } catch (e) { return null; }
      }

      /* ---------- Mitgliederbereich ---------- */
      var hub = document.getElementById('xl-hub');
      var i18n = document.getElementById('xl-i18n');
      if (!hub || !i18n) return;
      var T = {}; try { T = JSON.parse(i18n.textContent); } catch (e) {}
      var L = root.getAttribute('data-locale') || 'de';
      var R = root.getAttribute('data-root') || '';
      var nf; try { nf = new Intl.NumberFormat(L === 'en' ? 'en-GB' : L); } catch (e) { nf = { format: String }; }
      var df; try { df = new Intl.DateTimeFormat(L === 'en' ? 'en-GB' : L, { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' }); } catch (e) { df = null; }
      function eur(n) { return L === 'en' ? '€' + n : n + ' €'; }
      function f(s, o) { return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }
      function q(sel, el) { return (el || root).querySelector(sel); }
      function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
      var $bal = q('[data-x="bal"]', hub), $bar = q('[data-x="bar"]', hub), $next = q('[data-x="next"]', hub), $err = q('[data-x="err"]', hub);
      var TIERS = [];
      root.querySelectorAll('.rw[data-pts]').forEach(function (t) { TIERS.push({ el: t, pts: +t.getAttribute('data-pts'), v: t.getAttribute('data-v'), act: q('.rw-act', t), prod: null }); });
      var S = null, bal = 0, busy = false;

      /* Smile.js wird vom Smile-App-Embed geladen und für den angemeldeten Kunden initialisiert. */
      function smileReady(ms) {
        return new Promise(function (res, rej) {
          var t0 = Date.now(), tried = false;
          (function chk() {
            var s = window.Smile, c = null;
            if (s && s.customer) {
              try { c = s.customer.current(); } catch (e) { c = null; }
              if (c) return res(s);
              if (!tried && Date.now() - t0 > 6000 && window.SmileUI && window.SmileUI.customerToken) {
                tried = true;
                try { s.customer.login({ customerToken: window.SmileUI.customerToken }).catch(function () {}); } catch (e) {}
              }
            }
            if (Date.now() - t0 > ms) return rej(new Error('smile-timeout'));
            setTimeout(chk, 250);
          })();
        });
      }
      function panel(dl) {
        if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') { window.SmileUI.openPanel({ deep_link: dl }); }
        else { location.href = location.pathname + '?smile_deep_link=' + dl; }
      }
      root.querySelectorAll('[data-panel]').forEach(function (b) { b.addEventListener('click', function () { panel(b.getAttribute('data-panel')); }); });

      function fail() {
        $bal.textContent = '–'; $next.textContent = ''; $err.hidden = false;
        TIERS.forEach(function (t) { t.act.hidden = true; });
      }
      q('[data-x="retry"]', hub).addEventListener('click', function () { location.reload(); });

      function showBalance() {
        $bal.textContent = nf.format(bal);
        var next = null; for (var i = 0; i < TIERS.length; i++) { if (TIERS[i].pts > bal) { next = TIERS[i]; break; } }
        var pct = next ? Math.max(2, Math.min(100, bal / next.pts * 100)) : 100;
        $bar.style.width = pct + '%';
        $next.textContent = '';
        if (bal >= TIERS[0].pts) {
          var b = el('b', null, T.m_ready); $next.appendChild(b);
          $next.appendChild(document.createTextNode(' · ' + f(T.m_worth, { v: eur(Math.floor(bal / 1000) * 10) })));
        } else if (next) {
          $next.textContent = f(T.m_next, { n: nf.format(next.pts - bal), v: next.v });
        }
        TIERS.forEach(renderTier);
      }

      function renderTier(t) {
        var a = t.act; a.innerHTML = ''; a.hidden = false;
        t.el.classList.toggle('is-ok', bal >= t.pts && !!t.prod);
        if (!t.prod) { a.hidden = true; return; }
        if (bal < t.pts) { a.appendChild(el('div', 'xl-miss', f(T.r_missing, { n: nf.format(t.pts - bal) }))); return; }
        var b = el('button', null, T.r_btn); b.type = 'button';
        b.addEventListener('click', function () { confirmTier(t); });
        a.appendChild(b);
      }
      function confirmTier(t) {
        if (busy) return;
        var a = t.act; a.innerHTML = '';
        a.appendChild(el('p', 'xl-conf', f(T.r_confirm, { p: nf.format(t.pts), v: t.v })));
        var row = el('div', 'xl-row'), yes = el('button', null, T.r_yes), no = el('button', 'xl-ghost', T.r_no);
        yes.type = no.type = 'button'; row.appendChild(yes); row.appendChild(no); a.appendChild(row);
        no.addEventListener('click', function () { renderTier(t); });
        yes.addEventListener('click', function () { redeem(t, yes, no); });
        yes.focus();
      }
      function redeem(t, yes, no) {
        if (busy) return; busy = true;
        yes.disabled = no.disabled = true; yes.textContent = T.r_busy;
        var opts = t.prod.exchangeType === 'variable' ? { pointsToSpend: t.pts } : undefined;
        S.pointsProducts.purchase(t.prod.id, opts).then(function (pp) {
          var rf = pp && pp.rewardFulfillment;
          bal = Math.max(0, bal - ((pp && pp.pointsSpent) || t.pts));
          busy = false; showBalance();
          return refreshCoupons(rf && rf.id);
        }).then(function () {
          refreshWallet();
          var box = document.getElementById('xl-cps'); if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }).catch(function () {
          busy = false; renderTier(t);
          t.act.appendChild(el('p', 'xl-msg', T.r_err));
        });
      }
      function refreshWallet() {
        return S.customerPointsWallet.get().then(function (w) { if (w && typeof w.balance === 'number') { bal = w.balance; showBalance(); } }).catch(function () {});
      }

      function parseVoucher(rf) {
        var n = rf.name || '', v = n.match(/(\d+)\s*€\s*OFF/i) || n.match(/€\s*(\d+)/) || n.match(/(\d+)\s*€/);
        var m = n.match(/ab\s*(\d+)\s*€/i);
        if (!v) return n;
        var s = f(T.c_voucher, { v: eur(v[1]) });
        if (m) s += ' · ' + f(T.c_from, { m: eur(m[1]) });
        return s;
      }
      function copy(text, btn) {
        function ok() { var o = btn.textContent; btn.textContent = T.c_copied; setTimeout(function () { btn.textContent = o; }, 1600); }
        function fb() { var i = el('input'); i.value = text; i.setAttribute('readonly', ''); i.style.position = 'fixed'; i.style.opacity = '0'; document.body.appendChild(i); i.select(); try { document.execCommand('copy'); ok(); } catch (e) {} i.remove(); }
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(text).then(ok, fb); } else { fb(); }
      }
      function refreshCoupons(newId) {
        var box = document.getElementById('xl-cps'); if (!box) return Promise.resolve();
        var list = q('[data-x="list"]', box);
        function get(tries) {
          return S.rewardFulfillments.get().then(function (all) {
            all = (all || []).slice();
            if (newId && tries > 0) {
              var hit = all.filter(function (r) { return r.id === newId; })[0];
              if (!hit || !hit.code) return new Promise(function (r) { setTimeout(r, 1200); }).then(function () { return get(tries - 1); });
            }
            return all;
          });
        }
        return get(4).then(function (all) {
          var now = Date.now();
          var open = all.filter(function (r) {
            return r.code && (!r.fulfillmentStatus || r.fulfillmentStatus === 'issued') && !r.usedAt && (!r.expiresAt || Date.parse(r.expiresAt) > now);
          }).sort(function (a, b) { return Date.parse(b.createdAt || 0) - Date.parse(a.createdAt || 0); }).slice(0, 6);
          list.innerHTML = '';
          open.forEach(function (r) {
            var c = el('div', 'cp' + (r.id === newId ? ' is-new' : ''));
            if (r.id === newId) c.appendChild(el('p', 'cp-new', T.r_done));
            c.appendChild(el('p', 'cp-t', parseVoucher(r)));
            if (r.expiresAt && df) c.appendChild(el('p', 'cp-until', f(T.c_until, { d: df.format(new Date(r.expiresAt)) })));
            else c.appendChild(el('span'));
            c.appendChild(el('p', 'cp-code', r.code));
            var btns = el('div', 'cp-btns');
            var cb = el('button', null, T.c_copy); cb.type = 'button';
            cb.addEventListener('click', function () { copy(r.code, cb); });
            var ap = el('a', null, T.c_apply);
            ap.href = R + '/discount/' + encodeURIComponent(r.code) + '?redirect=' + encodeURIComponent(R + '/cart');
            btns.appendChild(cb); btns.appendChild(ap); c.appendChild(btns);
            list.appendChild(c);
          });
          box.hidden = open.length === 0;
        }).catch(function () {});
      }

      function referral() {
        var box = document.getElementById('xl-refbox'), url = refLink(); if (!box || !url) return;
        var inp = q('[data-x="url"]', box), btn = q('[data-x="copy"]', box), wa = q('[data-x="wa"]', box);
        inp.value = url;
        inp.addEventListener('focus', function () { inp.select(); });
        btn.addEventListener('click', function () { copy(url, btn); });
        wa.href = 'https://wa.me/?text=' + encodeURIComponent(String(T.ref_msg || '').replace('{f}', refF || '') + ' ' + url);
        box.hidden = false;
      }
      referral();

      function matchProducts(list) {
        TIERS.forEach(function (t) {
          t.prod = null;
          (list || []).forEach(function (p) {
            if (t.prod) return;
            if (p.exchangeType === 'fixed' && +p.pointsPrice === t.pts) t.prod = p;
          });
          if (!t.prod) (list || []).forEach(function (p) {
            if (t.prod || p.exchangeType !== 'variable') return;
            var step = +p.variablePointsStep || 0, min = +p.variablePointsMin || step;
            if (step && t.pts === Math.max(min, step)) t.prod = p;
          });
        });
      }

      smileReady(15000).then(function (s) {
        S = s;
        var c = S.customer.current() || {};
        if (c.state === 'disabled') { $bal.textContent = '–'; $next.textContent = T.m_disabled; $bar.style.width = '0'; return; }
        return Promise.all([
          S.customerPointsWallet.get().then(function (w) { return (w && typeof w.balance === 'number') ? w.balance : c.pointsBalance; }).catch(function () { return c.pointsBalance; }),
          S.pointsProducts.get().catch(function () { return []; })
        ]).then(function (r) {
          if (typeof r[0] !== 'number') throw new Error('no-balance');
          bal = r[0]; matchProducts(r[1]); showBalance();
          refreshCoupons(null);
        });
      }).catch(fail);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ex-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.exRevOn) return;
      root.dataset.exRevOn = '1';

      var track = root.querySelector('[data-ex-rev-track]');
      var bar = root.querySelector('[data-ex-rev-bar]');
      if (!track) return;
      var cards = track.querySelectorAll('.ex-rev__card');
      if (!cards.length) return;

      var slow = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var wait = (parseFloat(root.dataset.autoplay) || 5) * 1000;
      var timer = null;
      var hover = false;
      var touched = false;
      var seen = true;

      // Die Leiste ist so breit wie der sichtbare Anteil der Bahn und wandert
      // anteilig mit. translateX rechnet in Prozent der eigenen Breite.
      function paint() {
        if (!bar) return;
        var span = track.scrollWidth - track.clientWidth;
        var w = Math.max((track.clientWidth / track.scrollWidth) * 100, 12);
        var p = span > 0 ? track.scrollLeft / span : 0;
        bar.style.width = w + '%';
        bar.style.transform = 'translateX(' + (p * (100 - w) * 100) / w + '%)';
      }

      function step() {
        var span = track.scrollWidth - track.clientWidth;
        if (span <= 1) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 12;
        var next = track.scrollLeft + cards[0].getBoundingClientRect().width + gap;
        if (next > span - 4) next = 0;
        track.scrollTo({ left: next, behavior: slow ? 'auto' : 'smooth' });
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      function run() {
        stop();
        if (slow || hover || touched || !seen) return;
        if (track.scrollWidth - track.clientWidth <= 1) return;
        timer = setInterval(step, wait);
      }

      var resume = null;
      function pause(ms) {
        touched = true;
        stop();
        if (resume) clearTimeout(resume);
        resume = setTimeout(function () {
          touched = false;
          run();
        }, ms);
      }

      track.addEventListener('scroll', paint, { passive: true });
      track.addEventListener('pointerenter', function () { hover = true; stop(); });
      track.addEventListener('pointerleave', function () { hover = false; run(); });
      track.addEventListener('pointerdown', function () { pause(4000); });
      track.addEventListener('touchstart', function () { pause(4000); }, { passive: true });
      track.addEventListener('focusin', function () { hover = true; stop(); });
      track.addEventListener('focusout', function () { hover = false; run(); });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          seen = e[0].isIntersecting;
          run();
        }, { threshold: 0.2 }).observe(root);
      }

      window.addEventListener('resize', paint);
      paint();
      run();
    }

    function boot() {
      var list = document.querySelectorAll('[data-ex-rev]');
      for (var i = 0; i < list.length; i++) init(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
